import { IReferralOrganisation, queryKeys } from '../../shared';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { useItem, UseItemParams, useList, UseListParams } from '../../shared/hooks/new-read-only.hook';
import { referralOrganisationClient } from '../clients/referral-organisation.client';

const client = referralOrganisationClient;
const listKey = queryKeys.REFERRAL_ORGANISATIONS;
const itemKey = queryKeys.REFERRAL_ORGANISATION;

export function useReferralOrganisationList(...args: UseListParams<IReferralOrganisation>) {
    return useList(client, listKey, args);
}

export function useReferralOrganisation(...args: UseItemParams<IReferralOrganisation>) {
    return useItem(client, itemKey, args);
}

export function useSaveReferralOrganisation() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteReferralOrganisation() {
    return useDelete(client, listKey);
}
